// Shared with vite.config.mjs, whose Sentry plugin marks every chunk of our build with it.
export const SENTRY_APPLICATION_KEY = 'nightgraph-web';
